import {create} from 'zustand';

type EventPopupStore = {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
};

export const useEventPopupStore = create<EventPopupStore>((set) => ({
  isVisible: true,
  setIsVisible: (isVisible: boolean) => set({isVisible})
}));
